import { EnemyDamageNumber } from '@phaser/objects/EnemyDamageNumber.object';
import { FocusBehavior } from '@phaser/behaviors/Focus.behavior';
import { LevelBehavior } from '@phaser/behaviors/Level.behavior';
import { CardObject } from '@phaser/objects/Card.object';
import { CARD_HEIGHT } from '@phaser/scenes/Game';
import * as Shared from '@shared/lib';

export class EnemyObject extends CardObject {
  public targetIds: string[] = [];

  private _focusBehavior: FocusBehavior;

  constructor(data: Shared.CardSpawnMessage) {
    super(data);

    this.targetIds = data.enemy?.targetIds || [];

    this._focusBehavior = new FocusBehavior(this);

    new LevelBehavior(this);
  }

  public override destroy() {
    this._attackBehavior.destroy();
    this._effectBehavior.destroy();
    this.container.destroy();
  }

  public attack(message: Shared.CardAttackMessage) {
    this._attackBehavior.attack({ resetTimer: !message.isAbility });
    this._focusBehavior.updateFocus(message.damages.map(d => d.targetId));

    const damageMsg = message.damages.find(d => this._scene.id.startsWith(d.targetId));
    if (!damageMsg) return;

    const { x, y } = this.container;
    setTimeout(() => new EnemyDamageNumber(x, y + CARD_HEIGHT / 2 - 15, damageMsg.damage), 150);
  }
}